"use strict";

import Vue from 'vue';
import axios from "axios";

// Full config:  https://github.com/axios/axios#request-config
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL + process.env.VUE_APP_API_URL || '';

let config = {
  baseURL: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_API_URL || '',
  timeout: 60 * 1000, // Timeout
  withCredentials: true, // Check cross-site Access-Control
  xsrfHeaderName: "X-CSRFToken", // Django CSRF_HEADER_NAME
  xsrfCookieName: "csrftoken_abit", // Django CSRF_COOKIE_NAME
};

const _axios = axios.create(config);

_axios.interceptors.request.use(function (config) {
    return config;
  }, function (error) {
    return Promise.reject(error);
  });

_axios.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    return Promise.reject(error);
  });

Plugin.install = function (Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;
